<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <validated-text-field
          v-model="pilotInfo.licence_glider_number"
          field-name="licence_glider_number"
          rules=""
          type="text"
          autofocus
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <validated-text-field
          v-model="pilotInfo.licence_general_number"
          field-name="licence_general_number"
          rules=""
          type="text"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <data-selector
          v-model="pilotInfo.fai_level"
          translate
          autofocus
          rules=""
          field-name="fai_level"
          source-type="fai-levels"
        />
      </v-col>
    </v-row>
    <material-card
      color="accent"
      :title="$t('types.takeoff_types')"
      class="mb-6 pb-2 card-block"
    >
      <v-row class="px-2">
        <v-col
          cols="12"
          md="2"
        >
          <v-checkbox
            v-model="pilotInfo.glider_wl"
            :label="$t('fields.glider_wl')"
          />
        </v-col>
        <v-col
          cols="12"
          md="2"
        >
          <v-checkbox
            v-model="pilotInfo.glider_at"
            :label="$t('fields.glider_at')"
          />
        </v-col>
        <v-col
          cols="12"
          md="2"
        >
          <v-checkbox
            v-model="pilotInfo.glider_sl"
            :label="$t('fields.glider_sl')"
          />
        </v-col>
        <v-col
          cols="12"
          md="2"
        >
          <v-checkbox
            v-model="pilotInfo.glider_cl"
            :label="$t('fields.glider_cl')"
          />
        </v-col>
        <v-col
          cols="12"
          md="2"
        >
          <v-checkbox
            v-model="pilotInfo.glider_bl"
            :label="$t('fields.glider_bl')"
          />
        </v-col>
      </v-row>
    </material-card>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          {{ $t('fields.prev_flight_datas') }} ({{ $t('glider') }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <h4> {{ $t('takeoff_types') }} </h4>
          <v-row>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_glider_winching"
                field-name="prev_glider_winching"
                rules="required|numeric"
                type="number"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_glider_towing"
                field-name="prev_glider_towing"
                rules="required|numeric"
                type="number"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_glider_self_motor"
                field-name="prev_glider_self_motor"
                rules="required|numeric"
                type="number"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_glider_rubber"
                field-name="prev_glider_rubber"
                rules="required|numeric"
                type="number"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_glider_car_towing"
                field-name="prev_glider_car_towing"
                rules="required|numeric"
                type="number"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_glider_tmg"
                field-name="prev_glider_tmg"
                rules="required|numeric"
                type="number"
              />
            </v-col>
          </v-row>
          <h4> {{ $t('glider') }} </h4>
          <v-row>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_glider_flight_time"
                field-name="prev_glider_flight_time"
                rules="required|double"
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_glider_pic_time"
                field-name="prev_glider_pic_time"
                rules="required|double"
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_glider_dual_time"
                field-name="prev_glider_dual_time"
                rules="required|double"
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_glider_instructor_time"
                field-name="prev_glider_instructor_time"
                rules="required|double"
                type="text"
              />
            </v-col>
          </v-row>
          <h4> {{ $t('tmg') }} </h4>
          <v-row>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_glider_tmg_flight_time"
                field-name="prev_glider_tmg_flight_time"
                rules="required|double"
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_glider_tmg_pic_time"
                field-name="prev_glider_tmg_pic_time"
                rules="required|double"
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_glider_tmg_dual_time"
                field-name="prev_glider_tmg_dual_time"
                rules="required|double"
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_glider_tmg_instructor_time"
                field-name="prev_glider_tmg_instructor_time"
                rules="required|double"
                type="text"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          {{ $t('fields.prev_flight_datas') }} ({{ $t('general') }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_flight_time"
                field-name="flight_time"
                rules="required|double"
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_single_engine_time"
                field-name="prev_single_engine_time"
                rules="required|double"
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_multi_engine_time"
                field-name="prev_multi_engine_time"
                rules="required|double"
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_multi_pilot_time"
                field-name="prev_multi_pilot_time"
                rules="required|double"
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_night_time"
                field-name="prev_night_time"
                rules="required|double"
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_ifr_time"
                field-name="prev_ifr_time"
                rules="required|double"
                type="text"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_pic_time"
                field-name="pft_pic"
                rules="required|double"
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_copilot_time"
                field-name="pft_copilot"
                rules="required|double"
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_dual_time"
                field-name="pft_dual"
                rules="required|double"
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_instructor_time"
                field-name="pft_instructor"
                rules="required|double"
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <validated-text-field
                v-model="pilotInfo.prev_sim_time"
                field-name="prev_sim_time"
                rules="required|double"
                type="text"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="3"
            >
              <validated-text-field
                v-model="pilotInfo.prev_takeoff_day"
                field-name="takeoff_day"
                rules="required|numeric"
                type="number"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <validated-text-field
                v-model="pilotInfo.prev_takeoff_night"
                field-name="takeoff_night"
                rules="required|numeric"
                type="number"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <validated-text-field
                v-model="pilotInfo.prev_landing_day"
                field-name="landing_day"
                rules="required|numeric"
                type="number"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <validated-text-field
                v-model="pilotInfo.prev_landing_night"
                field-name="landing_night"
                rules="required|numeric"
                type="number"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
  export default {
    name: 'EditPilotInfo',
    props: {
      pilotInfo: Object,
    },
  }
</script>
